import { IoAlert, IoCheckmarkCircleOutline } from "react-icons/io5";
import ExitIcon from "../../assets/icons/ExitIcon";
import styles from "./NotificationToast.module.scss";

const NotificationToast = ({ id, message, status, removeNotification }) => {
  return (
    <div
      className={`${styles.toastbg} ${
        status === 200 ? styles.success : styles.error
      }`}
    >
      <div className={styles.toast}>
        <div className={styles.toastContent}>
          {status === 200 ? (
            <IoCheckmarkCircleOutline size={20} />
          ) : (
            <IoAlert size={20} />
          )}

          <p>{message}</p>
        </div>

        <ExitIcon color="white" onClick={() => removeNotification(id)} />
      </div>
    </div>
  );
};

export default NotificationToast;
